import React from 'react';
import { withI18n } from 'react-i18next';
import styled from 'styled-components';
import { Button, Paper, Typography } from '../../../Common';

type Props = {
  t: any;
  onEnableClick: () => void;
};

const DisabledInfoSheet: React.FC<Props> = ({
  t,
  onEnableClick: handleClick
}) => {
  return (
    <StyledPaper>
      <Typography
        color="darkGrey"
        component="h2"
        variant="h5"
      >
        {t('Info sheet has been disabled by default.')}
      </Typography>
      <Typography color="darkGrey">
        {t('If you wish to use the info sheet for your project enable info sheet.')}
      </Typography>
      <StyledButton onClick={handleClick}>
        {t('Enable info sheet')}
      </StyledButton>
    </StyledPaper>
  );
};

const StyledPaper = styled(Paper)`
  width: 100%;
  max-width: ${p => p.theme.spacing(130)};
  height: ${p => p.theme.spacing(27)};
  align-items: center;
  justify-content: space-between;
  margin: ${p => p.theme.spacing(5, 'auto')};
  padding: ${p => p.theme.spacing(4.5, 0, 5.5)};
`;

const StyledButton = styled(Button)`
  margin: ${p => p.theme.spacing(1, 0, 0)};
`;

export default withI18n()(DisabledInfoSheet);
